var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFunds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-8);}.cls-3{fill:url(#linear-gradient-9);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}.cls-9{fill:url(#linear-gradient-5);}.cls-10{fill:url(#linear-gradient-13);}.cls-11{fill:url(#linear-gradient-12);}.cls-12{fill:url(#linear-gradient-10);}.cls-13{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 130.15,
    y1: 155.52,
    x2: 35.07,
    y2: 60.43,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#babd42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82954b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 184.92,
    y1: 100.75,
    x2: 89.83,
    y2: 5.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 98.66,
    y1: 187,
    x2: 3.58,
    y2: 91.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 105.55,
    y1: 180.11,
    x2: 10.47,
    y2: 85.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 174.06,
    y1: 111.6,
    x2: 78.98,
    y2: 16.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 123.59,
    y1: 162.07,
    x2: 28.51,
    y2: 66.99,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 182.51,
    y1: 103.15,
    x2: 87.43,
    y2: 8.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 157.44,
    y1: 128.23,
    x2: 62.35,
    y2: 33.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 189.52,
    y1: 160.01,
    x2: 117.71,
    y2: 88.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 199.97,
    y1: 149.56,
    x2: 128.16,
    y2: 77.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 150.27,
    y1: 199.25,
    x2: 78.47,
    y2: 127.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 160.26,
    y1: 189.27,
    x2: 88.46,
    y2: 117.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 171.27,
    y1: 178.26,
    x2: 99.46,
    y2: 106.46,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.14,51.8l62.69,35.67-46.65,19.94c-.48,.22-1.02,.32-1.56,.32-.67,0-1.33-.16-1.97-.51L4.6,76.48c-1.33-.73-2.1-2.16-2.03-3.65,.1-1.52,1.02-2.83,2.41-3.43l41.16-17.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M183.15,53.29c-.1,1.49-1.02,2.83-2.41,3.43l-42.33,18.1-62.66-35.7,47.8-20.42c1.14-.51,2.45-.44,3.53,.19l54.09,30.71c1.3,.76,2.1,2.16,2,3.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.19,142.76c2.41,1.94,5.75,3.43,9.62,4.51l-35.63,15.24c-.48,.22-1.02,.32-1.56,.32-.67,0-1.33-.16-1.97-.51L4.6,131.61c-1.94-1.08-2.6-3.53-1.49-5.43,1.08-1.91,3.49-2.57,5.4-1.49l52.37,29.76,27.31-11.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.2,133.39l-25.03,10.7c-.48,.22-1.02,.32-1.56,.32-.67,0-1.33-.16-1.97-.51L4.6,113.16c-1.94-1.08-2.6-3.49-1.49-5.4,1.08-1.91,3.49-2.57,5.4-1.49l52.37,29.76,24.39-10.42v2.6c0,1.94,.7,3.65,1.94,5.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.73,93.4l-39.1,16.7c-.98-.57-2.06-1.11-3.24-1.59v-5.65l39.22-16.77c2-.86,4.35,.06,5.21,2.1,.86,2-.06,4.35-2.1,5.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.88,117.64l49.19-21.02v8.61l-47.89,20.48c-.48,.22-1.02,.32-1.56,.32-.67,0-1.33-.16-1.97-.51L4.6,94.8c-1.94-1.08-2.6-3.53-1.49-5.43,1.08-1.91,3.49-2.57,5.4-1.49l52.37,29.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M180.73,75.02l-42.33,18.1v-8.64l39.22-16.77c2-.86,4.35,.06,5.21,2.1,.86,2-.06,4.35-2.1,5.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.05,78.51v28.04c-4.83-1.14-10.29-1.68-15.63-1.68v-20.39L53.51,48.62l14.89-6.35,63.64,36.24Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.44,132.66v8.16c0,8.92-15.34,12.99-29.6,12.99-11.46,0-23.63-2.64-27.95-8.29,3.53-1.56,6.22-3.59,7.59-6.1v-.16c2.6,.95,5.53,1.65,8.64,2.16,.54,.1,1.11,.19,1.68,.25,.6,.1,1.21,.16,1.84,.22,.7,.1,1.43,.16,2.13,.19,1.08,.1,2.19,.16,3.33,.19,.92,.06,1.81,.06,2.73,.06,12.58,0,26.01-3.05,29.6-9.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M167.84,105.38c8.51,0,15.91,1.49,19.66,3.65,1.68,.98,2.64,2.1,2.64,3.24,0,3.81-9.97,6.92-22.29,6.92s-22.29-3.11-22.29-6.92c0-1.14,.95-2.25,2.64-3.24,3.75-2.16,11.15-3.65,19.66-3.65Zm0-5.56c-12,0-24.76,2.88-28.51,9.11-.7,1.17-1.09,2.47-1.09,3.88v2.56c1.02,.82,1.59,1.69,1.59,2.62s-.56,1.81-1.59,2.62v1.41c0,1.37,.35,2.61,.99,3.72,1.38,2.39,4.07,4.3,7.54,5.75,5.71,2.39,13.54,3.52,21.07,3.52,12.01,0,24.71-2.89,28.49-9.11,.7-1.18,1.08-2.45,1.08-3.88v-9.21c0-8.92-15.31-12.99-29.57-12.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M147.48,159.4v8.57c0,9.37-16.13,13.66-31.12,13.66s-31.09-4.29-31.09-13.66v-8.57c3.78,6.96,17.88,10.16,31.09,10.16s27.34-3.21,31.12-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M147.48,139.42v8.57c0,9.37-16.13,13.66-31.12,13.66s-31.09-4.29-31.09-13.66v-8.54c1.68,3.02,5.3,5.34,9.94,6.99,1.14,.41,2.35,.79,3.65,1.11,5.3,1.37,11.5,2.03,17.5,2.03,13.24,0,27.34-3.21,31.12-10.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M116.36,104.87c-14.96,0-31.09,4.29-31.09,13.66v9.69c0,9.37,16.13,13.66,31.09,13.66s31.12-4.29,31.12-13.66v-9.69c0-9.37-16.13-13.66-31.12-13.66Zm0,5.88c8.96,0,16.74,1.56,20.71,3.81,1.75,1.05,2.76,2.19,2.76,3.43,0,4-10.51,7.24-23.47,7.24s-23.44-3.24-23.44-7.24c0-1.24,1.02-2.38,2.76-3.43,3.94-2.25,11.75-3.81,20.67-3.81Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFunds);
export default __webpack_public_path__ + "static/media/icon-funds.e9df8f4bc0568c389b5c1d20cbba7765.svg";
export { ForwardRef as ReactComponent };